module.exports = __webpack_public_path__ + "img/fineness-1@2x.57923c4.png";